export default {
    getRequestError(state){
      return state.request_error;
    },
    getAllVisits(state) {
      return state.visits;
    },
    getCurrentVisitId(state){
      return state.current_visit_id;
    },
    getCurrentVisitPerson(state){
      return state.current_person;
    },
    getItemsFromSearch(state){
      return state.items_of_search;
    },
    getItemFromScan(state){
      return state.item_of_scan;
    },
    getSelectedItems(state){
      return state.selected_items;
    },
    getInsertedItemId(state){  // not used yet
      return state.inserted_item_id;
    },
    getVisitFlag(state){
      return state.edit_visit_flag;
    }

  };